import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Input,
  Select,
} from '@lockerpm/design';

import {
  SearchOutlined
} from "@ant-design/icons";

import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import commonComponents from "../../../../../components/common";

const Filter = (props) => {
  const { Sort } = commonComponents;
  const { t } = useTranslation()
  const {
    className = '',
    loading = false,
    params = {},
    setParams = () => { }
  } = props;

  const [name, setName] = useState(params.name || '');
  const searchTimeoutRef = useRef(null);

  useEffect(() => {
    setName(params.name || '');
  }, [params.name]);

  return (
    <Row
      className={`filter ${className}`}
      justify={'space-between'}
      align={'bottom'}
      gutter={[12, 12]}
    >
      <Col xl={18} lg={18} md={16} xs={24}>
        <Row
          justify={'left'}
          gutter={[12, 12]}
        >
          <Col xl={6} lg={8} md={10} xs={12}>
            <p className="font-semibold mb-1">{t('environment.name')}</p>
            <Input
              prefix={<SearchOutlined />}
              value={name}
              placeholder={t('placeholder.enter')}
              onChange={(e) => {
                const val = e.target.value;
                setName(val);
                if (searchTimeoutRef.current) {
                  clearTimeout(searchTimeoutRef.current);
                }
                searchTimeoutRef.current = setTimeout(() => {
                  setParams({ ...params, name: val });
                }, 500);
              }}
            />
          </Col>
        </Row>
      </Col>
      <Col className="flex items-end mb-[1px]">
        <Sort
          loading={loading}
          params={params}
          setParams={setParams}
        />
      </Col>
    </Row>
  );
}

export default Filter;
